import { type ReduxUser } from 'models';
import { type NodeUserDataObject } from 'models/service';

export const canViewEhrPortal = ({ viewer, nodeViewer }: { viewer: ReduxUser; nodeViewer?: NodeUserDataObject }) =>
  viewer.superadmin ||
  nodeViewer?.membership?.some((membership) => membership.role === 'navigator' && membership.type === 'cohort');
